import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueLazyload from "vue-lazyload";
import "./assets/tailwind.css";
import { MotionPlugin } from "@vueuse/motion";

const app = createApp(App);

app.use(router);

app.use(VueLazyload, {
  loading: require("@/assets/logos/loading.webp"), // Ensure these paths are correct
});

app.use(MotionPlugin);

app.mount("#app");
